import Bluebird from 'bluebird';
import {observable, action} from 'mobx';
import abortable from 'utils/abortable';
import makeAbortable from 'abortable-promise';
import importScript from 'utils/importScript';

// import tracker from 'tracker';

/* global FB */

class FacebookState {
  @action init() {
    return importScript(
      `//connect.facebook.net/${
        /* translators: see https://developers.facebook.com/docs/internationalization#locales */
        this.ctx.i18n._x('en_UK', 'facebook sdk locale')
      }/sdk.js`,
      'facebook-jssdk',
    );
  }

  async getRequest(loginData, {isAborted}) {
    const loginResponse = await (() => {
      let isResolved = false;
      let result;

      let resolve = (_result) => {
        isResolved = true;
        result = _result;
      };

      // Note: this must be called synchronosly so don't put an await before this point.
      FB.getLoginStatus((statusResponse) => {
        if (statusResponse.status === 'connected') {
          resolve(statusResponse);
          return;
        }

        FB.login((response) => {
          resolve(response);
        }, {
          scope: 'public_profile,email',
          auth_type: 'rerequest',
        });
      });


      return new Bluebird((_resolve) => {
        if (isResolved) {
          _resolve(result);
        } else {
          resolve = _resolve;
        }
      });
    })();
    if (isAborted()) return;

    if (loginResponse && loginResponse.authResponse) {
      // if logged in, check user info
      const profile = await new Bluebird(resolve =>
        FB.api('/me', {fields: 'id, name, email, gender, birthday'}, resolve));
      if (isAborted()) return;

      if (profile && profile.email && profile.email.length > 0) {
        const {cityId, ...rest} = loginData;

        if (!cityId) {
          // FIXME - show city dropdown popup
          if (isAborted()) return;
        }

        const {json} = await this.ctx.sdk.post('/auth/oauth', {
          ...rest,
          profile: {
            homeCity_id: cityId,
          },
          adapter: 'facebook',
          type: 'customer',
          secure: {
            token: loginResponse.authResponse.accessToken,
          },
        });
        if (isAborted()) return;

        return json; // eslint-disable-line consistent-return
      }

      FB.logout();
      if (isAborted()) return;

      throw Object.assign(new Error('Missing email address in facebook info'), {
        code: 'FACEBOOK_LOGIN_MISSING_EMAIL',
        profile,
      });
    }
    throw Object.assign(new Error('Facebook login cancelled'), {
      code: 'FACEBOOK_LOGIN_CANCELLED',
    });
  }

  @action async load(loginData) {
    if (this.isLoading) return this.lastLoad;

    const _abortable = abortable();
    this.abort = _abortable.abort;

    this.isLoading = true;
    this.error = null;

    const {promise} = makeAbortable(this.getRequest(loginData, _abortable));
    this.lastLoad = promise;

    try {
      return await promise;
    } catch (error) {
      this.onError(error);
      throw error;
    } finally {
      this.always();
    }
  }

  @observable isLoading = false;
  @observable error = null;

  @action onError(error) {
    this.error = error;
  }
  @action always() {
    this.isLoading = false;
  }

  @action reset() {
    if (this.abort) this.abort();
    this.error = null;
    this.isLoading = false;
    // TODO - close facebook popup
  }

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });
  }
}

export default FacebookState;



// WEBPACK FOOTER //
// ./spa/state/session/facebook.jsx